import { IModuleType } from '../interfaces/module-type.interface';

// @dynamic
export class ModuleTypes {
    static all: IModuleType[] = [
        {
            name: 'course',
            translationLabel: 'MODULE.TYPE.BASIC',
            icon: 'course',
        },
        {
            name: 'e_learning',
            translationLabel: 'MODULE.TYPE.E-LEARNING',
            icon: 'e_learning',
        },
        {
            name: 'private',
            translationLabel: 'MODULE.TYPE.PRIVATE',
            icon: 'course_private',
        },
        {
            name: 'program',
            translationLabel: 'MODULE.TYPE.PROGRAM',
            icon: 'program',
        },
    ];
}
